import { combineReducers } from 'redux';
import bankReducer from './bank/reducers';
import systemReducer from './system/reducers';

export default combineReducers({
  bank: bankReducer,
  system: systemReducer,
});
